import React from "react";
import PropTypes from 'prop-types';

export default class Slide extends React.Component {
    img = {};
    render() {
        const {
            slide,
            index,
            currentSlideIndex,
            onClick,
            onActiveImageLoad,
            onImageLoad,
            offset,
            isHtml,
            isPlaceholder,
            mainImageHeight,
        } = this.props;

        const isActive = currentSlideIndex === index;
        const className = isActive ? 'active' : 'side';
        const style = {
            "--offset": offset,
        };

        return (
            <div
                className={`slide ${className} ${isPlaceholder ? 'slide-placeholder placeholder' : ''}`}
                style={style}
                onClick={onClick}
            >
                {isHtml ? slide : <img
                    onLoad={e => {
                        this.img = e.target;

                        onImageLoad(e.target, index);

                        // not sure why there was a condition to handle
                        // front image loading, it breaks placeholder functionality
                        /*if (!isActive) {
                            return false;
                        }*/

                        return onActiveImageLoad(e.target);
                    }}
                    style={{
                        height: mainImageHeight ? mainImageHeight : '100%',
                        // we need min height for placeholders while images still loading
                        minHeight: isPlaceholder ? 300 : 'auto',
                    }}
                    alt={'screen'}
                    src={slide}
                />}
            </div>
        );
    }
}

Slide.propTypes = {
    isHtml: PropTypes.bool,
    isPlaceholder: PropTypes.bool,
    slide: PropTypes.node.isRequired,
    index: PropTypes.number.isRequired,
    mainImageHeight: PropTypes.number.isRequired,
    currentSlideIndex: PropTypes.number.isRequired,
    offset: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    onActiveImageLoad: PropTypes.func.isRequired,
    onImageLoad: PropTypes.func.isRequired,
};
